import { Screen50 } from "../../../../src/components/images/support/users/Screen50.generated";
import { Screen51 } from "../../../../src/components/images/support/users/Screen51.generated";
import { Screen52 } from "../../../../src/components/images/support/users/Screen52.generated";
import * as React from 'react';
export default {
  Screen50,
  Screen51,
  Screen52,
  React
};